import moment from "moment";
import { Dispatch } from "../Dispatch";
import { PaymentCardErrorType, PaymentOption } from "./PaymentEntities";

/** If a payment card is selected, check if it is expired and set an error message to display (and to block booking creation). */
export function CheckForCardExpiry(paymentOption: PaymentOption) {
    if (!paymentOption.Card) return;

    const { CardExpiry, CardType } = paymentOption.Card;
    const isDigitalPass = CardType.replace(/\s/g, "").toUpperCase().includes("DIGITALPASS");
    const expiresAt = isDigitalPass
        ? moment(CardExpiry, "DD/MM/YY")
        : moment(CardExpiry, "MM/YY").add(1, "month");

    const atNow = moment();
    const isExpired = expiresAt.isBefore(atNow);

    if (isExpired) {
        Dispatch.Payment.CardErrorMessage(PaymentCardErrorType.CardExpired);
    }
}